import PropTypes from 'prop-types';
import { Magnet } from 'lucide-react';
import { useGrid } from '../../context/GridContext';

/**
 * SnapToggleButton — click/tap control to turn snap-to-grid on or off in the
 * wizard drawing steps (#752).
 *
 * The wizard canvas previously offered only the Ctrl-hold override to draw
 * without snapping, which does not exist on touch. This button uses the shared
 * `toggleSnap` from GridContext so snap can be flipped by finger on iPad; the
 * Magnet-icon styling mirrors the Editor's GridControls for consistency.
 *
 * The min 44px height keeps it a comfortable touch target. On desktop the
 * Ctrl-hold override remains available for a momentary, non-persistent bypass.
 *
 * `className` lets the host tune layout (e.g. `w-full justify-center` in a
 * sidebar vs. inline in a button row).
 */
const SnapToggleButton = ({ className = '' }) => {
  const { snapEnabled, toggleSnap } = useGrid();

  return (
    <button
      type="button"
      onClick={toggleSnap}
      aria-pressed={snapEnabled}
      className={`min-h-[44px] px-3 py-1 text-xs font-medium rounded-md transition-colors flex items-center gap-1.5 ${
        snapEnabled
          ? 'bg-emerald-600 text-white hover:bg-emerald-700'
          : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
      } ${className}`}
      title={
        snapEnabled
          ? 'Einrasten am Raster ist an — tippen zum Ausschalten (am Desktop: Strg zum temporären Deaktivieren)'
          : 'Einrasten am Raster ist aus — tippen zum Einschalten'
      }
    >
      <Magnet size={14} />
      <span>{snapEnabled ? 'Einrasten: An' : 'Einrasten: Aus'}</span>
    </button>
  );
};

SnapToggleButton.propTypes = {
  className: PropTypes.string,
};

export default SnapToggleButton;
